import * as React from 'react';

import Rheostat from 'rheostat/lib/Slider';

import './style.scss';

interface Props {
    min: number;
    max: number;
    values: number[];
    snap: boolean;
    snapPoints?: number[];
    pitComponent?: React.ComponentType<{ style: React.CSSProperties }>;
    pitPoints?: number[];
    onSliderDragEnd?: () => void;
    onChange?: (result: { max: number; min: number; values: number[] }) => void;
    onValuesUpdated?: (result: { max: number; min: number; values: number[] }) => void;
}

export const Slider = ({min, max, values, snap, snapPoints, onChange, onSliderDragEnd, pitComponent, pitPoints, onValuesUpdated}: Props) => (
    <Rheostat
        min={min}
        max={max}
        values={values}
        snap={snap}
        snapPoints={snapPoints}
        onSliderDragEnd={onSliderDragEnd}
        onChange={onChange}
        pitComponent={pitComponent}
        pitPoints={pitPoints}
        onValuesUpdated={onValuesUpdated}
    />
);
